export default "__VITE_ASSET__B5854Ixa__"